import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

const Phonepesuccess = () => {

    const navigate = useNavigate();

    const time = setTimeout(() => {
        navigate('/')
    }, 10000);


    const [data, setData] = useState({})
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const transactionId = urlParams.get('transaction_id');
        const amount = urlParams.get('amount');
        setData({ 'transactionId': transactionId, 'amount': amount })
    }, []);


    return (
        <div class="main-container">
            <div class="check-container">
                <div class="check-background-success">
                    <svg viewBox="0 0 65 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 25L27.3077 44L58.5 7" stroke="white" stroke-width="13" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="check-shadow-success"></div>

            </div>
            <h2 class="">Payment Successful</h2>
            <div class="pament-table">

                <div class="pb-20 payment-wrapper">
                    <span class="id-title">Transaction Id</span>
                    <span class="dot ">:</span>
                    <span class="id-value">{data?.transactionId}</span>
                </div>
                <div class="payment-wrapper">
                    <span class="id-title">Amount</span>
                    <span class="dot ">:</span>
                    <span class="id-value">{data?.amount}</span>
                </div>

            </div>
            <p class="message"> Do not refresh or close this window.<br /> You will be redirected to Taskde.</p>
        </div>
    )
}

export default Phonepesuccess;